import React from 'react';
import { useTheme } from '../../../styles/ThemeProvider';

export const ErrorState = ({ message = 'Bir sorun oluştu', onRetry }) => {
  const { theme } = useTheme();
  return (
    <div style={{ textAlign: 'center', padding: theme.space.xxl, color: theme.color.danger }}>
      <div style={{ fontSize: theme.font.size.lg, fontWeight: theme.font.weight.semibold, marginBottom: theme.space.sm }}>{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            background: theme.color.accent, color: '#fff', border: 'none',
            padding: `${theme.space.sm}px ${theme.space.base}px`,
            borderRadius: theme.radius.sm, cursor: 'pointer',
            fontFamily: theme.font.family, fontSize: theme.font.size.sm,
          }}>
          Tekrar dene
        </button>
      )}
    </div>
  );
};
